import { Pipe, PipeTransform } from '@angular/core';
import { Config } from '../../models/ui.interfaces';
@Pipe({
  name: 'skymilesError'
})
/**
 * Takes a Error Message object and replaces  passnumber string with passenger number.
 * @example
 *
 * Input
 * {
 *    invalidYearFieldCheckOfDOB: {
 *       "Whoops! We're sorry, please enter a valid Secure Flight Date of Birth for passenger { passNumber }."
 * }
 *
 * Output
 * {
 *    invalidYearFieldCheckOfDOB: {
 *       "Whoops! We're sorry, please enter a valid Secure Flight Date of Birth for passenger 1."
 * }
 * @constructor
 * @param {Config} errorMessages - Error Message object.
 * @param {number} passengerIndex - Passenger index.
 */
export class SkymilesErrorMessagePipe implements PipeTransform {
  transform(msg: string, config: Config): string {
    for (const errorKey in config) {
      msg = msg.replace('{' + errorKey + '}', config[errorKey]);
    }
    return msg;
  }
}
